import React from 'react';
import NavBar from './navbar';
import { useFirebase } from '../lib/firebaseContext';
import styles from '@/styles/components/_landingPage.module.css';

interface LayoutProps {
  children: React.ReactNode;
  showDevBanner?: boolean;
  useCustomClass?: boolean;
  useContainer?: boolean;
}

export default function Layout({ 
  children, 
  showDevBanner, 
  useCustomClass = false
}: LayoutProps): JSX.Element {
  const { 
    firebaseService, 
    isAuthenticated, 
    currentUser, 
    authLoading, 
    firebaseInitialized 
  } = useFirebase();
  
  const isProduction = process.env.NODE_ENV === 'production';
  const content = (
    <>
      <NavBar
        firebaseService={firebaseService}
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        authLoading={authLoading}
        firebaseInitialized={firebaseInitialized}
      />
      {!isProduction && showDevBanner && (
        <div className="dev-banner" style={{
          background: '#ff6b35',
          color: 'white',
          padding: '8px',
          textAlign: 'center',
          fontSize: '14px'
        }}>
          🔧 Development Mode - Authentication Not Required
        </div>
      )}
      <main style={useCustomClass ? {} : {
        paddingTop: '80px',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #030304 0%, #070709 100%)'
      }}>
        {children}
      </main>
    </>
  );

  return (
    <div className={useCustomClass ? styles.landingPageWrapper : "container"}>
      {content}
    </div>
  );
}